import React, { useEffect, useState } from 'react';
export function TopCountdownBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 w-full bg-alert-red py-2 px-4 z-50 flex items-center justify-center gap-4 sm:gap-6" data-id="element-393">
      <span className="font-inter text-xs sm:text-sm text-white uppercase tracking-wider font-semibold" data-id="element-394">
        ⚠️ ATENCIÓN: Precio especial de lanzamiento expira en:
      </span>
      <span className="font-bebas text-2xl sm:text-3xl text-white" data-id="element-395">
        {formattedTime}
      </span>
    </div>;
}